module.exports = __webpack_public_path__ + "img/china-map.f7d3f20a.png";